
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"59","viewBox":"0 0 60 59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.39 58.048L30.096 50l-15.212 8.151a3.023 3.023 0 01-3.206-.225 3.072 3.072 0 01-1.036-1.325 3.105 3.105 0 01-.188-1.676l2.857-17.159L.928 25.661a3.106 3.106 0 01-.778-3.149 3.08 3.08 0 01.928-1.404c.433-.371.96-.613 1.522-.698l17.063-2.56 7.555-15.63A3.067 3.067 0 0128.34.97a3.026 3.026 0 013.215 0c.482.303.872.735 1.124 1.249l7.647 15.576 17.063 2.443c.562.082 1.09.32 1.526.689.435.368.759.852.936 1.397a3.106 3.106 0 01-.758 3.154L46.822 37.65l2.971 17.137a3.1 3.1 0 01-.172 1.68 3.067 3.067 0 01-1.024 1.333 3.024 3.024 0 01-3.206.247z","fill":"#FFD56A"}})])
          )
        }
      }
    